import React, {useRef, useState } from "react";
import { IonPage } from "@ionic/react";
import { TiPen } from "react-icons/ti";
import { FaEraser, FaUndo } from "react-icons/fa";
import { Container, SelectContaner, Footer, IconContaner, ButtonContaner } from "./style";
import InputColor from "rb-react-input-color";
import "./style.css";
import CanvasDraw from "react-canvas-draw";
import { isPlatform } from '@ionic/react';

interface props {
  showModal: any;
  width: any;
  height: any;
}

interface CanvasProps {
  width?: number;
  height?: number;
  open?: any;
  imgData: any;
  onSave: any;
}

type Coordinate = {
  x: number;
  y: number;
};

const Canvas = ({ imgData, onSave }: CanvasProps) => {
  const [color, setColor] = React.useState<any>("#ff0000");
  const [isPainting, setIsPainting] = useState(true);
  let canvasDrawRef = useRef<CanvasDraw>(null);

  const startDraw = () => {
    setIsPainting(!isPainting);
  };

  function undo() {
    console.log("undo", canvasDrawRef);
    if (canvasDrawRef && canvasDrawRef.current) {
      canvasDrawRef.current.undo();
    }
  }

  function clear() {
    console.log("clear", canvasDrawRef);
    if (canvasDrawRef && canvasDrawRef.current) {
      canvasDrawRef.current.clear();
    }
  }

  function save() {
    console.log("save", canvasDrawRef);
    const draw: { blob: any; dataUri: any } | undefined = combineDrawing();
    if (draw) {
      console.log({ draw, imgData });
      imgData.base64 = draw.dataUri;
      onSave(imgData);
    }
  }

  function combineDrawing() {
    const canvasRef: any = canvasDrawRef;
    if (canvasRef && canvasRef.current) {
      const width = canvasRef.current.props.canvasWidth;
      const height = canvasRef.current.props.canvasHeight;
      const background = canvasRef.current.canvasContainer.children[0];
      const drawing = canvasRef.current.canvasContainer.children[1];
      const canvas: any = document.createElement("canvas");
      console.log({width, height, background, drawing, canvas}, canvasRef.current.canvasContainer.children)
      if (canvas) {
        canvas.width = width;
        canvas.height = height;

        canvas.getContext("2d").drawImage(background, 0, 0);
        canvas.getContext("2d").globalAlpha = 1.0;
        canvas.getContext("2d").drawImage(drawing, 0, 0);

        const dataUri = canvas.toDataURL("image/jpeg", 1.0);
        const data = dataUri.split(",")[1];
        const mimeType = dataUri.split(";")[0].slice(5);

        const bytes = window.atob(data);
        const buf = new ArrayBuffer(bytes.length);
        const arr = new Uint8Array(buf);

        for (let i = 0; i < bytes.length; i++) {
          arr[i] = bytes.charCodeAt(i);
        }

        const blob = new Blob([arr], { type: mimeType });
        return { blob: blob, dataUri: dataUri };
      }
    }
  }

  return (
    <IonPage>
      <Container>
        {/* <TransformWrapper pinch={pinch} panning={pinch} doubleClick={pinch} onZoomStop={onzoomstop}>
          <TransformComponent> */}
            <CanvasDraw ref={canvasDrawRef} brushColor={color.hex} imgSrc={imgData.base64} canvasWidth={window.innerWidth} 
              canvasHeight={window.innerHeight - (isPlatform('ios') ? 200 : 150)} brushRadius={3} lazyRadius={1} disabled={!isPainting} />
          {/* </TransformComponent>
        </TransformWrapper> */}
        <Footer>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <IconContaner color={isPainting ? "#666666" : "white"} onClick={startDraw}>
              <TiPen color={"black"} size="1rem" />
            </IconContaner>
            <IconContaner color="white" onClick={() => clear()}>
              <FaEraser color={"black"} size="1rem" />
            </IconContaner>
            <IconContaner color="white" onClick={() => undo()}>
              <FaUndo color={"black"} size="1rem" />
            </IconContaner>
            <SelectContaner color="white">
              <div style={{ display: "flex", alignItems: "center" }}>
                <InputColor initialValue="#ff0000" onChange={setColor} placement="right" />
                {/* <MdKeyboardArrowDown /> */}
              </div>
            </SelectContaner>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ButtonContaner color="white" onClick={() => save()}>
              Save
            </ButtonContaner>
          </div>
        </Footer>
      </Container>
    </IonPage>
  );
};

Canvas.defaultProps = {
  width: window.innerWidth,
  height: window.innerHeight,
};

export default Canvas;
